(() => {
  const drawer = document.getElementById('TsukiCart');
  if (!drawer) return;
  let busy = false;
  let returnFocus;
  let quantityTimer;
  let refreshNumber = 0;
  let giftEventsBound = false;
  let giftRefreshPending = false;
  let ownRequestUrl = '';
  // When the drawer's lines last came from the server (this page's HTML counts).
  let cartFreshAt = Date.now();
  let beforePreview = null;
  const upsellSelections = new Map();
  let countdownDeadline = 0;
  const timerKey = () => 'tsukiglass-checkout-timer-' + (drawer.querySelector('[data-cart-content]')?.dataset.cartCurrency || 'USD');
  const itemCount = () => Number(drawer.querySelector('[data-cart-content]')?.dataset.itemCount || 0);
  const readDeadline = () => { try { return Number(localStorage.getItem(timerKey())) || 0; } catch { return countdownDeadline; } };
  const updateCountdown = () => {
    if (document.hidden) return;
    document.querySelectorAll('[data-cart-countdown]').forEach(time => {
      if (time.closest('[hidden], dialog:not([open])')) return;
      const remaining = Math.max(0, Math.ceil((countdownDeadline - Date.now()) / 1000));
      const value = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
      if (time.textContent !== value) time.textContent = value;
      const label = time.parentElement.querySelector('[data-cart-countdown-label]');
      const text = remaining ? label.dataset.active : label.dataset.ended;
      if (label.textContent !== text) label.textContent = text;
      const suffix = time.parentElement.querySelector('[data-cart-countdown-suffix]');
      if (suffix) suffix.hidden = !remaining;
    });
  };
  const startCountdown = () => {
    if (!itemCount()) return;
    const now = Date.now(), stored = readDeadline();
    countdownDeadline = stored > now && stored <= now + 600000 ? stored : now + 600000;
    try { localStorage.setItem(timerKey(), String(countdownDeadline)); } catch {}
    updateCountdown();
  };
  const selectUpsell = input => {
    const card = input.closest('[data-upsell-handle]');
    card.dataset.selectedVariant = input.value;
    card.dataset.selectedMin = input.dataset.min || '1';
    if (input.dataset.priceCents) { card.dataset.selectedPrice = input.dataset.priceCents; card.dataset.selectedCompare = input.dataset.compareCents || '0'; card.dataset.selectedTitle = input.dataset.variantTitle || ''; }
    card.querySelector('[data-upsell-price]').textContent = input.dataset.price;
    const compare = card.querySelector('[data-upsell-compare]');
    compare.textContent = input.dataset.compare || ''; compare.hidden = !input.dataset.compare;
    const discount = card.querySelector('[data-upsell-discount]');
    discount.textContent = input.dataset.discount || ''; discount.hidden = !input.dataset.discount;
    upsellSelections.set(card.dataset.upsellHandle, input.value);
  };
  const syncDetails = () => {
    document.querySelectorAll('[data-cart-content]').forEach(content => {
      const currency = content.dataset.cartCurrency;
      const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
      const subtotal = Number(content.dataset.cartTotal);
      // Gift thresholds follow EasyGift's basis (prices before discounts, free gifts excluded).
      const rewardTotal = Number(content.dataset.rewardTotal || content.dataset.cartTotal);
      const rewards = content.querySelector('[data-rewards]');
      if (rewards && Number.isFinite(rate) && rate > 0) {
        const thresholds = [500, 10900].map(value => Math.round(value * rate));
        const unlocked = thresholds.map((value, index) => (index === 1 ? rewardTotal : subtotal) >= value || (index === 1 && rewards.dataset.stonesIncluded === 'true'));
        const next = unlocked.findIndex(value => !value);
        // Markers sit at 15% and 88% (the stones label stays at 78%); once both are unlocked the line fills the whole bar.
        const progress = next === -1 ? 100 : next === 0 ? subtotal / thresholds[0] * 15 : 15 + (rewardTotal - thresholds[0]) / (thresholds[1] - thresholds[0]) * 73;
        const amount = next === -1 ? '' : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format((thresholds[next]-(next === 1 ? rewardTotal : subtotal))/100);
        const message = next === -1 ? rewards.dataset.unlocked : (next === 0 ? rewards.dataset.shippingMessage : rewards.dataset.giftMessage).replace('{amount}',amount);
        rewards.hidden = false;
        rewards.querySelector('[data-cart-reward-message]').textContent = message;
        rewards.querySelector('[data-cart-reward-fill]').style.width = Math.max(0, Math.min(100, progress)) + '%';
        const track = rewards.querySelector('[role=progressbar]');track.setAttribute('aria-valuenow',String(Math.round(progress)));track.setAttribute('aria-valuetext',message);
        rewards.querySelectorAll('[data-cart-reward-tier]').forEach((tier,i)=>tier.classList.toggle('is-unlocked',unlocked[i]));
        const shipping = content.querySelector('[data-cart-shipping]');
        if(shipping)shipping.textContent = subtotal >= thresholds[0] ? shipping.dataset.free : shipping.dataset.fallback;
      }
      content.querySelectorAll('[data-upsell-handle]').forEach(card => {
        const saved = upsellSelections.get(card.dataset.upsellHandle);
        const input = [...card.querySelectorAll('[data-upsell-option]')].find(input=>input.value === saved) || card.querySelector('[data-upsell-option]:checked');
        if(input){input.checked=true;selectUpsell(input);}
      });
    });
    if (!itemCount()) { countdownDeadline=0;try{localStorage.removeItem(timerKey());}catch{} }
    updateCountdown();
  };
  countdownDeadline = readDeadline();
  let countdownTimer = null;
  const syncCountdownTimer = () => {
    const needed = drawer.open || !!document.querySelector('main [data-cart-countdown]');
    if (needed && !countdownTimer) countdownTimer = setInterval(updateCountdown, 1000);
    if (!needed && countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  };
  syncCountdownTimer();
  document.addEventListener('visibilitychange', updateCountdown);
  const root = () => window.Shopify?.routes?.root || '/';
  const announce = text => { const status=document.getElementById('TsukiStatus');if(status)status.textContent = text; };
  const stepQuantity = button => {
    const input = button.closest('.tgcart-qty').querySelector('[data-cart-quantity]');
    const quantity = Number(input.value) + Number(button.dataset.cartStep) * (Number(input.step) || 1);
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    return {input, quantity, allowed: Number.isInteger(quantity) && quantity >= min && quantity <= max};
  };
  const setBusy = value => {
    busy = value;
    document.querySelectorAll('[data-product-form] button, .tgcart-form button, [data-cart-quantity]').forEach(el => {
      const unavailable = el.name === 'add' && el.form.querySelector('[name=id]:checked')?.dataset.available === 'false';
      const atLimit = el.matches('[data-cart-step]') && !stepQuantity(el).allowed;
      el.disabled = value || unavailable || atLimit;
    });
    document.querySelectorAll('[data-cart-remove]').forEach(el => el.setAttribute('aria-disabled', String(value)));
    drawer.setAttribute('aria-busy', String(value));
  };
  const reportError = (message, form) => {
    const candidates = form ? [form.querySelector('[data-form-error]')] : [...document.querySelectorAll('[data-cart-error], [data-cart-page-error]')];
    candidates.filter(Boolean).forEach(el => { el.hidden = false; el.textContent = message; });
    announce(message);
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html || '', 'text/html');
    const fresh = parsed.querySelector('[data-cart-content]');
    if (!fresh) throw new Error(drawer.dataset.error);
    cartFreshAt = Date.now();
    beforePreview = null;
    drawer.classList.remove('is-pending');
    // Keep the empty-cart frame used by instant previews (the section only sends it while the cart is empty).
    const shell = parsed.querySelector('template[data-cart-shell]');
    if (shell && !drawer.querySelector('template[data-cart-shell]')) drawer.append(document.importNode(shell, true));
    // Pictures in an open drawer load right away instead of waiting for the lazy-load check.
    if (drawer.open) fresh.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    const active = document.activeElement;
    const focusKey = active?.dataset.key;
    const focusQuantity = active?.matches('[data-cart-quantity]');
    const focusStep = active?.dataset.cartStep;
    const focusInDrawer = !!active?.closest('dialog');
    document.querySelectorAll('[data-cart-content]').forEach(old => {
      const scrollTop = old.querySelector('.tgcart-body')?.scrollTop || 0;
      const copy = fresh.cloneNode(true);
      const context = old.closest('dialog') ? 'drawer' : 'page';
      copy.querySelectorAll('[id]').forEach(el => { el.id = el.id.replace('-drawer', '-' + context); });
      copy.querySelectorAll('[for]').forEach(el => { el.htmlFor = el.htmlFor.replace('-drawer', '-' + context); });
      copy.querySelectorAll('[aria-labelledby]').forEach(el => { el.setAttribute('aria-labelledby', el.getAttribute('aria-labelledby').replaceAll('-drawer', '-' + context)); });
      old.replaceWith(copy);
      const lines = copy.querySelector('.tgcart-body');
      if (lines) lines.scrollTop = scrollTop;
    });
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = fresh.dataset.itemCount; });
    syncDetails();
    if (focusKey) {
      const scope = focusInDrawer ? drawer : document.querySelector('main');
      const selector = focusQuantity ? '[data-cart-quantity]' : focusStep ? `[data-cart-step="${focusStep}"]` : '[data-cart-remove]';
      const candidates = [...scope.querySelectorAll(selector)];
      const next = candidates.find(el => el.dataset.key === focusKey) || candidates[0];
      const focusTarget = next?.disabled ? next.closest('.tgcart-qty').querySelector('input') : next;
      focusTarget?.focus({preventScroll: true});
    }
  };
  const refresh = async () => {
    const requestNumber = ++refreshNumber;
    const response = await fetch(root() + '?sections=tg-cart', {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(drawer.dataset.error);
    const sections = await response.json();
    if (requestNumber === refreshNumber) render(sections['tg-cart']);
  };
  const open = () => {
    startCountdown();
    if (drawer.open) return;
    returnFocus = document.activeElement;
    drawer.showModal();
    updateCountdown();
    syncCountdownTimer();
    document.body.classList.add('tg-locked');
  };
  drawer.addEventListener('close', () => {
    document.body.classList.remove('tg-locked');
    syncCountdownTimer();
    returnFocus?.focus({preventScroll: true});
  });
  // Open the drawer the moment an add starts (like the previous UpCart drawer) and show
  // an "Adding" state until the server cart, including app-added gifts, is rendered.
  let addingCount = 0;
  let openedForAdd = false;
  const startAdding = form => {
    addingCount++;
    drawer.classList.add('is-adding');
    if (!drawer.open) { openedForAdd = true; open(); }
    const copy = form?.querySelector('[data-add-copy]');
    if (copy && drawer.dataset.adding && copy.dataset.previousLabel === undefined) {
      copy.dataset.previousLabel = copy.textContent;
      copy.textContent = drawer.dataset.adding;
    }
    if (drawer.dataset.adding) announce(drawer.dataset.adding);
  };
  const stopAdding = (form, failed) => {
    addingCount = Math.max(0, addingCount - 1);
    const copy = form?.querySelector('[data-add-copy]');
    if (copy && copy.dataset.previousLabel !== undefined) {
      copy.textContent = copy.dataset.previousLabel;
      delete copy.dataset.previousLabel;
    }
    if (addingCount) return;
    drawer.classList.remove('is-adding');
    // On failure, close a drawer we opened so the shopper sees the error next to the button.
    if (failed && openedForAdd && drawer.open) drawer.close();
    openedForAdd = false;
  };
  const bindGiftEvents = () => {
    if (giftEventsBound || !window.EasyGift?.Events?.subscribe) return;
    giftEventsBound = true;
    window.EasyGift.Events.subscribe('afterCartRequest', detail => {
      // Our own requests come back with the cart already rendered (sections), so they need no second fetch.
      if (busy && ownRequestUrl && String(detail?.url || '') === ownRequestUrl) return;
      if (busy) giftRefreshPending = true; else refresh().catch(error => reportError(error.message));
    });
  };
  // EasyGift can still change the cart after a request has been answered (e.g. re-applying its rules).
  // Its own requests carry ?_easygift_internal; when one finishes while we are idle, show the new cart.
  let lateGiftTimer;
  // Gift requests EasyGift makes while one of ours is in flight are already in our answer.
  const ownWindow = {start: -1, end: -1};
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(list => {
        if (!list.getEntries().some(entry => entry.name.includes('_easygift_internal') && !(entry.startTime >= ownWindow.start && entry.startTime <= ownWindow.end))) return;
        clearTimeout(lateGiftTimer);
        lateGiftTimer = setTimeout(() => { if (busy) giftRefreshPending = true; else refresh().catch(() => {}); }, 300);
      }).observe({type: 'resource'});
    } catch { /* older browsers: afterCartRequest still refreshes */ }
  }

  // ---- Fast add -------------------------------------------------------------------------------
  // EasyGift adds each free gift with its own request BEFORE it lets the product through (gift, gift,
  // product: three ~0.7 s round trips). We send the product and the gifts EasyGift is certain to add in
  // ONE request; EasyGift still checks that request and adds anything we did not send, so the cart ends
  // up exactly as before. The drawer also shows the product the moment it is tapped.
  const moneySample = drawer.dataset.moneySample || '';
  const money = cents => {
    const m = moneySample.match(/^(.*?)1([^\d]?)234(?:([^\d])(\d\d))?(.*)$/);
    const value = Math.round(Math.abs(cents));
    if (!m) return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
    const whole = String(Math.floor(value / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2] || '');
    return (cents < 0 ? '-' : '') + m[1] + whole + (m[4] ? (m[3] || '.') + String(value % 100).padStart(2, '0') : '') + m[5];
  };
  // Mirrors EasyGift's "add automatically" rules (trigger count = floor(sum / min) capped by the rule limit,
  // gift quantity = rule quantity x count, minus that rule's gift already in the cart). Only rules whose
  // outcome is certain are predicted; anything else is left for EasyGift to add itself.
  const predictGifts = (rules, lines, adds, opts) => {
    const rate = Number(opts.rate) > 0 ? Number(opts.rate) : 1;
    const margin = 0.02;
    const amount = value => { const n = Number(String(value).replace(',', '.')); return Number.isFinite(n) ? parseInt(Math.round(n * 100) * rate, 10) : NaN; };
    const near = (value, edge) => Number.isFinite(edge) && Math.abs(value - edge) <= edge * margin;
    const blank = value => value === null || value === undefined || String(value).trim() === '';
    const cart = [...lines, ...adds.map(item => ({...item, gifted: ''}))];
    const paid = cart.filter(line => !line.gifted && line.qty > 0);
    const out = [];
    for (const rule of Array.isArray(rules) ? rules : []) {
      const t = rule?.trigger, a = rule?.action, targeting = rule?.targeting || {}, criteria = targeting.additionalCriteria || {};
      if (!t || !a || rule.active !== true || rule.testMode || rule.schedule?.enabled || a.type !== 'addAutomatically') continue;
      if (targeting.type !== 'all' || targeting.link?.destination || rule.settings?.runsOncePerSession) continue;
      if ((criteria.geo?.include || []).length || (criteria.geo?.exclude || []).length || (criteria.customerTags || []).length ||
          (criteria.customerTagsExcluded || []).length || (criteria.customerId || []).length || !blank(criteria.orderCount) || !blank(criteria.totalSpent) || !blank(criteria.type)) continue;
      if (t.promoCode || t.hybrid || (t.collections || []).length || (t.productTags?.targets || []).length) continue;
      if ((a.products || []).some(p => (p?.alerts || []).some(alert => alert?.type === 'outOfStock'))) continue;
      let count = 0;
      if (t.type === 'productsInclude') {
        const products = (t.products || []).filter(p => !blank(p?.variantId));
        if (!products.length || products.some(p => (p.sellingPlans || []).length)) continue;
        const ids = new Set(products.map(p => String(p.variantId)));
        const matching = paid.filter(line => ids.has(String(line.variant)) && !line.plan);
        if (t.condition === 'quantity') {
          const sum = matching.reduce((s, line) => s + line.qty, 0);
          const min = parseInt(t.conditionMin, 10) || 1;
          const max = parseInt(t.conditionMax, 10);
          count = max && sum > max ? 0 : Math.floor(sum / min);
        } else if (t.condition === 'value') {
          if (!opts.valueRules || blank(t.conditionMin)) continue;
          const sum = matching.reduce((s, line) => s + line.qty * line.price, 0);
          const min = amount(t.conditionMin), max = blank(t.conditionMax) ? Infinity : amount(t.conditionMax);
          if (!(min > 0) || Number.isNaN(max) || near(sum, min) || near(sum, max)) continue;
          count = sum > max ? 0 : Math.floor(sum / min);
        } else continue;
      } else if (t.type === 'cartValue') {
        if (!opts.valueRules || blank(t.minCartValue)) continue;
        const excluded = t.cartValueExcludedVariants || [];
        if (excluded.some(v => (v?.sellingPlans || []).length)) continue;
        const skip = new Set(excluded.map(v => String(v?.variantId ?? v)));
        const sum = paid.filter(line => !skip.has(String(line.variant))).reduce((s, line) => s + line.qty * line.price, 0);
        const min = amount(t.minCartValue), upper = blank(t.upperCartValue) ? Infinity : amount(t.upperCartValue);
        if (!(min > 0) || Number.isNaN(upper) || near(sum, min) || near(sum, upper)) continue;
        count = sum >= min && sum <= upper ? Math.floor(sum / min) : 0;
      } else continue;
      const limit = parseInt(a.limit, 10);
      if (limit > 0) count = Math.min(count, limit);
      if (!(count > 0)) continue;
      for (const p of a.products || []) {
        if (blank(p?.variantId) || p.sellingPlanId) continue;
        const id = String(p.variantId);
        const target = (parseInt(p.quantity, 10) || 1) * count;
        const existing = cart.filter(line => line.gifted === rule.name && String(line.variant) === id).reduce((s, line) => s + line.qty, 0);
        if (target > existing) out.push({id: Number(id), quantity: target - existing, properties: {_Gifted: rule.name}});
      }
    }
    return out;
  };
  // Cart lines as the drawer shows them (server-rendered with data-* for this purpose).
  const cartLines = () => [...drawer.querySelectorAll('[data-cart-content] .tgcart-item[data-variant-id]')].map(el => ({
    variant: Number(el.dataset.variantId), qty: Number(el.dataset.quantity) || 0, price: Number(el.dataset.price) || 0, gifted: el.dataset.gifted || '', plan: el.hasAttribute('data-plan')
  }));
  // Price-based gift rules (e.g. ice stones from $109) are only predicted where EasyGift prices the item
  // from the page itself (no server lookup): the product of the page being viewed, in US dollars, with a
  // cart the drawer showed recently. Checked against EasyGift's own decisions for every gift product.
  const PRICE_RULES_FOR_PAGE_PRODUCT = true;
  const giftsFor = (item, price, pageProduct) => {
    if (!window.EasyGift?.Events || item.selling_plan) return [];
    try {
      const rules = JSON.parse(document.getElementById('easygift-rules')?.content || 'null');
      const shop = JSON.parse(document.getElementById('easygift-shop')?.content || 'null');
      // The drawer marks gift lines by EasyGift's default "_Gifted" property; a renamed property means no prediction.
      if (!Array.isArray(rules) || !shop?.settings || (shop.settings.addedItemIdentifier || '_Gifted') !== '_Gifted') return [];
      const rate = Number(window.Shopify?.currency?.rate) || 1;
      const valueRules = PRICE_RULES_FOR_PAGE_PRODUCT && pageProduct && window.Shopify?.currency?.active === 'USD' && rate === 1 && Date.now() - cartFreshAt < 1800000;
      return predictGifts(rules, cartLines(), [{variant: item.id, qty: item.quantity, price, plan: false}], {rate, valueRules});
    } catch { return []; }
  };
  const formItem = form => {
    const data = new FormData(form);
    const item = {id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1};
    const properties = {};
    for (const [name, value] of data.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
    }
    if (Object.keys(properties).length) item.properties = properties;
    const plan = data.get('selling_plan');
    if (plan) item.selling_plan = Number(plan);
    return item;
  };
  const formPreview = (form, item) => {
    try {
      const data = JSON.parse(form.querySelector('script[data-cart-preview]')?.textContent || 'null');
      const variant = data?.variants?.[item.id];
      if (!variant) return null;
      return {title: data.title, variantTitle: data.single ? '' : variant.t, image: variant.image || data.image || '', price: Number(variant.p) || 0, compare: Number(variant.c) || 0, quantity: item.quantity};
    } catch { return null; }
  };
  const upsellPreview = (card, quantity) => {
    const input = card.querySelector('[data-upsell-option]:checked');
    const price = Number(input?.dataset.priceCents ?? card.dataset.selectedPrice);
    if (!Number.isFinite(price) || !card.dataset.cartTitle) return null;
    return {title: card.dataset.cartTitle, variantTitle: card.dataset.single === 'true' ? '' : (input?.dataset.variantTitle ?? card.dataset.selectedTitle ?? ''), image: card.querySelector('.tgcart-upsell-image')?.innerHTML || '',
      price, compare: Number(input?.dataset.compareCents ?? card.dataset.selectedCompare) || 0, quantity};
  };
  // Shows the added product (and a placeholder for each gift on its way) in the drawer right away.
  // The server's cart replaces it as soon as it arrives; on failure the server cart is shown again.
  const showPreview = (preview, gifts) => {
    let content = drawer.querySelector('[data-cart-content]');
    let list = content?.querySelector('.tgcart-items');
    if (!content) return false;
    const original = content.cloneNode(true);
    if (!list) {
      const frame = drawer.querySelector('template[data-cart-shell]')?.content.querySelector('[data-cart-content]');
      if (!frame) return false;
      const filled = frame.cloneNode(true);
      content.replaceWith(filled);
      content = filled;
      list = content.querySelector('.tgcart-items');
      if (!list) return false;
    }
    const line = preview.price * preview.quantity;
    const regular = Math.max(preview.compare * preview.quantity, line);
    const giftUnits = gifts.reduce((sum, gift) => sum + gift.quantity, 0);
    const article = document.createElement('article');
    article.className = 'tgcart-item tgcart-item--pending';
    article.innerHTML = '<span class="tgcart-image"></span><div class="tgcart-info"><div class="tgcart-item-top"><div><h3 class="tgcart-item-name"></h3></div><div class="tgcart-prices"><span class="tgcart-price"></span></div></div>' +
      '<div class="tgcart-item-bottom"><div class="tgcart-qty"><button type="button" disabled tabindex="-1">−</button><input type="number" disabled tabindex="-1"><button type="button" disabled tabindex="-1">+</button></div><span class="tgcart-remove"></span></div></div>';
    const picture = article.querySelector('.tgcart-image');
    picture.innerHTML = preview.image;
    picture.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
    article.querySelector('.tgcart-item-name').textContent = preview.title;
    if (preview.variantTitle) { const variant = document.createElement('p'); variant.className = 'tgcart-variant'; variant.textContent = preview.variantTitle; article.querySelector('.tgcart-item-name').after(variant); }
    article.querySelector('.tgcart-price').textContent = money(line);
    if (regular > line) {
      const compare = document.createElement('s');
      compare.className = 'tgcart-compare-price';
      compare.innerHTML = '<span class="tg-sr"></span>';
      compare.firstChild.textContent = (drawer.dataset.labelCompare || '') + ' ';
      compare.append(money(regular));
      article.querySelector('.tgcart-prices').append(compare);
    }
    article.querySelector('.tgcart-qty input').value = String(preview.quantity);
    article.querySelector('.tgcart-remove').textContent = drawer.dataset.labelRemove || '';
    // Gift boxes show no "Free gift included" label (as in the server cart).
    const giftBoxVariants = (content.dataset.giftBoxVariants || '').split(',').map(Number);
    const placeholders = gifts.map(giftItem => {
      const gift = document.createElement('article');
      gift.className = 'tgcart-item tgcart-item--gift-pending';
      gift.innerHTML = '<span class="tgcart-image"></span><div class="tgcart-info"><div class="tgcart-item-top"><div><span class="tgcart-skeleton"></span><span class="tgcart-skeleton tgcart-skeleton--short"></span></div></div>' +
        '<div class="tgcart-item-bottom"><div class="tgcart-qty tgcart-qty--fixed"><span class="tgcart-item-discount"></span></div></div></div>';
      gift.querySelector('.tgcart-item-discount').textContent = giftBoxVariants.includes(Number(giftItem.id)) ? '' : drawer.dataset.labelFree || '';
      return gift;
    });
    list.prepend(article, ...placeholders);
    list.setAttribute('aria-busy', 'true');
    const body = content.querySelector('.tgcart-body');
    if (body) body.scrollTop = 0;
    const total = (Number(content.dataset.cartTotal) || 0) + line;
    const currency = content.dataset.cartCurrency || 'USD';
    content.dataset.cartTotal = String(total);
    content.dataset.rewardTotal = String((Number(content.dataset.rewardTotal) || 0) + line);
    content.dataset.itemCount = String((Number(content.dataset.itemCount) || 0) + preview.quantity + giftUnits);
    const subtotal = content.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(total) + (currency === 'USD' ? '' : ' ' + currency);
    const checkoutTotal = content.querySelector('[data-cart-checkout-total]');
    if (checkoutTotal) checkoutTotal.textContent = money(total);
    const savings = content.querySelector('[data-cart-savings]');
    if (savings && regular > line) {
      const saved = (Number(savings.dataset.savings) || 0) + regular - line;
      savings.dataset.savings = String(saved);
      savings.textContent = '−' + money(saved);
      savings.closest('.tgcart-savings').hidden = false;
    }
    // Ice stones on their way as a gift already unlock the rewards bar's last step (as in the server cart).
    const rewards = content.querySelector('[data-rewards]');
    if (rewards && gifts.some(gift => /stone/i.test(gift.properties?._Gifted || ''))) rewards.dataset.stonesIncluded = 'true';
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = content.dataset.itemCount; });
    content.querySelectorAll('.tgcart-checkout[name="checkout"]').forEach(button => { button.disabled = true; });
    drawer.classList.add('is-pending');
    syncDetails();
    startCountdown();
    beforePreview = {target: content, copy: original};
    return true;
  };
  // +/−/Remove: the new line total, subtotal and count show at once; Shopify's cart replaces them when it answers.
  const previewQuantity = (line, quantity) => {
    const content = line?.closest('[data-cart-content]');
    const oldQty = Number(line?.dataset.quantity) || 0;
    if (!content || !oldQty || quantity === oldQty) return;
    const copy = content.cloneNode(true);
    const oldLine = Number(line.dataset.linePrice) || 0;
    const oldRegular = Math.max(Number(line.dataset.regularPrice) || 0, oldLine);
    const newLine = Math.round(oldLine / oldQty * quantity);
    const newRegular = Math.round(oldRegular / oldQty * quantity);
    const price = line.querySelector('.tgcart-price');
    if (price) price.textContent = money(newLine);
    const compare = line.querySelector('.tgcart-compare-price');
    if (compare?.lastChild?.nodeType === Node.TEXT_NODE) compare.lastChild.textContent = money(newRegular);
    const total = Math.max(0, (Number(content.dataset.cartTotal) || 0) + newLine - oldLine);
    const currency = content.dataset.cartCurrency || 'USD';
    content.dataset.cartTotal = String(total);
    if (!line.dataset.gifted) content.dataset.rewardTotal = String(Math.max(0, (Number(content.dataset.rewardTotal) || 0) + (Number(line.dataset.price) || 0) * (quantity - oldQty)));
    content.dataset.itemCount = String(Math.max(0, (Number(content.dataset.itemCount) || 0) + quantity - oldQty));
    const subtotal = content.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(total) + (currency === 'USD' ? '' : ' ' + currency);
    const checkoutTotal = content.querySelector('[data-cart-checkout-total]');
    if (checkoutTotal) checkoutTotal.textContent = money(total);
    const savings = content.querySelector('[data-cart-savings]');
    if (savings) {
      const saved = Math.max(0, (Number(savings.dataset.savings) || 0) + (newRegular - newLine) - (oldRegular - oldLine));
      savings.dataset.savings = String(saved);
      savings.textContent = '−' + money(saved);
    }
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = content.dataset.itemCount; });
    content.querySelectorAll('.tgcart-checkout[name="checkout"]').forEach(button => { button.disabled = true; });
    if (content.closest('dialog')) drawer.classList.add('is-pending');
    syncDetails();
    beforePreview = {target: content, copy};
  };
  // EasyGift settles its intercepted cart requests on a 200 ms timer. Serialize only
  // AnyTrack's attribution-only update around our mutations, allowing 250 ms to settle.
  // Native product/gift requests, attribution data, consent and vendor settings stay intact.
  function createAttributionRequestQueue(host, options = {}) {
    const settleMs = options.settleMs === undefined ? 250 : options.settleMs;
    const acquireTimeoutMs = options.acquireTimeoutMs === undefined ? 10000 : options.acquireTimeoutMs;
    const xhrPrototype = host.XMLHttpRequest.prototype;
    const metadata = new WeakMap();
    const pending = new Map();
    const active = new Set();
    const inFlight = new Map();
    const idleWaiters = new Set();
    let metadataQuietUntil = 0;
    let idleTimer = null;
    const ownOpen = new WeakSet();
    const ownSend = new WeakSet();
    const ownAbort = new WeakSet();
    const installations = [];
    const now = () => host.Date.now();
    let settleUntil = 0;
    let timer = null;
    let disposed = false;

    function isAttributionOnly(body) {
      if (typeof body === 'string') {
        const text = body.trim();
        if (text.startsWith('{')) {
          try {
            const payload = JSON.parse(text);
            const attributes = payload && payload.attributes;
            return !!(payload && !Array.isArray(payload) && Object.keys(payload).length === 1 &&
              attributes && typeof attributes === 'object' && !Array.isArray(attributes) &&
              Object.keys(attributes).length === 1 &&
              typeof attributes.__atclid === 'string' && attributes.__atclid.length);
          } catch { return false; }
        }
        body = new host.URLSearchParams(body);
      }
      if (body instanceof host.URLSearchParams || (host.FormData && body instanceof host.FormData)) {
        const entries = [...body.entries()];
        return entries.length === 1 && entries[0][0] === 'attributes[__atclid]' &&
          typeof entries[0][1] === 'string' && entries[0][1].length > 0;
      }
      return false;
    }

    function isMetadataRequest(args) {
      if (String(args[0]).toUpperCase() !== 'POST' || (args[2] !== undefined && !args[2])) return false;
      try {
        const url = new host.URL(String(args[1]), host.location.href);
        const localeRoot = new host.URL(host.Shopify?.routes?.root || '/', host.location.origin);
        const prefix = localeRoot.pathname.endsWith('/') ? localeRoot.pathname : localeRoot.pathname + '/';
        const exactRoot = /^\/cart\/update(?:\.js|\.json)?$/.test(url.pathname);
        const exactLocale = url.pathname.startsWith(prefix) && /^cart\/update(?:\.js|\.json)?$/.test(url.pathname.slice(prefix.length));
        return url.origin === host.location.origin && !url.search && !url.hash && (exactRoot || exactLocale);
      } catch { return false; }
    }

    function clearTimer() {
      if (timer !== null) host.clearTimeout(timer);
      timer = null;
    }

    function notifyMetadataIdle() {
      if (idleTimer !== null) host.clearTimeout(idleTimer);
      idleTimer = null;
      if (inFlight.size) return;
      if (now() < metadataQuietUntil) {
        idleTimer = host.setTimeout(notifyMetadataIdle, metadataQuietUntil - now());
        return;
      }
      for (const resolve of idleWaiters) resolve();
      idleWaiters.clear();
    }

    function finishMetadata(xhr, record) {
      const flight = inFlight.get(xhr);
      if (!flight || flight.record !== record) return;
      xhr.removeEventListener('loadend', flight.finish);
      inFlight.delete(xhr);
      metadataQuietUntil = Math.max(metadataQuietUntil, now() + settleMs);
      notifyMetadataIdle();
    }

    function observeMetadata(xhr, record) {
      const finish = () => finishMetadata(xhr, record);
      inFlight.set(xhr, { record, finish });
      xhr.addEventListener('loadend', finish);
    }

    function waitForMetadata() {
      if (!inFlight.size && now() >= metadataQuietUntil) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const ready = () => { host.clearTimeout(timeout); idleWaiters.delete(ready); resolve(); };
        const timeout = host.setTimeout(() => {
          idleWaiters.delete(ready);
          reject(new Error(options.waitingError || 'The cart is still updating. Please try again.'));
        }, acquireTimeoutMs);
        idleWaiters.add(ready);
        notifyMetadataIdle();
      });
    }

    function sendOriginal(job) {
      if (metadata.get(job.xhr) !== job.record || job.xhr.readyState !== 1) return;
      // Also bypass older copies of our wrapper underneath subsequently installed vendor wrappers.
      job.record.dispatched = true;
      observeMetadata(job.xhr, job.record);
      try {
        const result = job.original.apply(job.xhr, job.args);
        // EasyGift's send wrapper is asynchronous; clean up if it fails before native send.
        if (result && typeof result.then === 'function') result.catch(error => {
          finishMetadata(job.xhr, job.record);
          if (typeof host.reportError === 'function') host.reportError(error);
        });
        return result;
      } catch (error) {
        finishMetadata(job.xhr, job.record);
        job.record.dispatched = false;
        throw error;
      }
    }

    function flush() {
      clearTimer();
      if (active.size) return;
      if (!disposed && now() < settleUntil) {
        timer = host.setTimeout(flush, settleUntil - now());
        return;
      }
      for (const [xhr, job] of [...pending]) {
        if (active.size) break;
        pending.delete(xhr);
        try { sendOriginal(job); }
        catch (error) {
          // A deferred exception cannot be thrown synchronously to the original caller.
          // Surface it normally; do not fake a response, success event, or callback.
          if (typeof host.reportError === 'function') host.reportError(error);
          else host.setTimeout(() => { throw error; }, 0);
        }
      }
    }

    function installCurrentWrappers() {
      if (!ownOpen.has(xhrPrototype.open)) {
        const original = xhrPrototype.open;
        const wrapper = function (...args) {
          const result = original.apply(this, args);
          pending.delete(this);
          finishMetadata(this, metadata.get(this));
          metadata.set(this, { eligible: isMetadataRequest(args), dispatched: false });
          return result;
        };
        ownOpen.add(wrapper);
        installations.push(['open', wrapper, original]);
        xhrPrototype.open = wrapper;
      }
      if (!ownAbort.has(xhrPrototype.abort)) {
        const original = xhrPrototype.abort;
        const wrapper = function (...args) {
          pending.delete(this);
          finishMetadata(this, metadata.get(this));
          metadata.delete(this);
          return original.apply(this, args);
        };
        ownAbort.add(wrapper);
        installations.push(['abort', wrapper, original]);
        xhrPrototype.abort = wrapper;
      }
      if (!ownSend.has(xhrPrototype.send)) {
        const original = xhrPrototype.send;
        const wrapper = function (...args) {
          const record = metadata.get(this);
          if (pending.has(this)) throw new host.DOMException('Request has already been sent.', 'InvalidStateError');
          if (disposed || !record?.eligible || record.dispatched || this.readyState !== 1 ||
              !isAttributionOnly(args[0])) {
            return original.apply(this, args);
          }
          if (!active.size && now() >= settleUntil) return sendOriginal({ xhr: this, record, original, args });
          pending.set(this, { xhr: this, record, original, args });
          if (!active.size) flush();
          return undefined;
        };
        ownSend.add(wrapper);
        installations.push(['send', wrapper, original]);
        xhrPrototype.send = wrapper;
      }
    }

    const controller = {
      begin() {
        if (disposed) throw new Error('Attribution request queue has been disposed.');
        installCurrentWrappers();
        const token = {};
        active.add(token);
        clearTimer();
        let released = false;
        return function release() {
          if (released) return;
          released = true;
          active.delete(token);
          settleUntil = Math.max(settleUntil, now() + settleMs);
          if (!active.size) flush();
        };
      },
      async acquire() {
        const release = controller.begin();
        try { await waitForMetadata(); return release; }
        catch (error) { release(); throw error; }
      },
      dispose() {
        disposed = true;
        active.clear();
        settleUntil = 0;
        flush();
        // Never overwrite a later vendor's wrapper. Disabled nested copies become pass-through.
        for (const [name, wrapper, original] of installations.reverse()) {
          if (xhrPrototype[name] === wrapper) xhrPrototype[name] = original;
        }
      },
      get pendingCount() { return pending.size; },
      get inFlightCount() { return inFlight.size; }
    };
    installCurrentWrappers();
    return controller;
  }
  const attributionRequestQueue = createAttributionRequestQueue(window, { waitingError: drawer.dataset.error });
  // The cart request also asks for the drawer's HTML (Shopify bundled section rendering), so the
  // updated cart arrives with the answer instead of needing a second request afterwards.
  const post = (endpoint, body) => {
    ownRequestUrl = root() + endpoint;
    ownWindow.start = performance.now(); ownWindow.end = Infinity;
    return fetch(ownRequestUrl, {
      method: 'POST',
      headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'X-TG-Cart': '1'},
      body: JSON.stringify({...body, sections: 'tg-cart', sections_url: root()})
    });
  };
  const mutate = async (endpoint, payload, form, adding = !!form, {preview = null, gifts = []} = {}) => {
    if (busy) return;
    setBusy(true);
    bindGiftEvents();
    document.querySelectorAll('[data-form-error], [data-cart-error], [data-cart-page-error]').forEach(el => { el.hidden = true; });
    let releaseAttributionRequest;
    let failed = false;
    let previewing = false;
    const product = payload.items ? payload.items[payload.items.length - 1] : null;
    const productBefore = product ? cartLines().filter(line => line.variant === product.id && !line.gifted).reduce((sum, line) => sum + line.qty, 0) : 0;
    if (adding && preview) {
      if (!drawer.open) { openedForAdd = true; open(); }
      previewing = showPreview(preview, gifts);
      if (previewing && drawer.dataset.adding) announce(drawer.dataset.adding);
    }
    if (adding && !previewing) startAdding(form);
    try {
      releaseAttributionRequest = await attributionRequestQueue.acquire();
      let response = await post(endpoint, payload);
      let result = response ? await response.json().catch(() => ({})) : null;
      ownWindow.end = performance.now();
      if (response && !response.ok && gifts.length && product) {
        // A gift may be unavailable right now. If the product did not go in, send it alone:
        // EasyGift then adds whatever gifts it can, exactly as before.
        const cart = await fetch(root() + 'cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json()).catch(() => null);
        const productAfter = (cart?.items || []).filter(line => line.variant_id === product.id && !line.properties?._Gifted).reduce((sum, line) => sum + line.quantity, 0);
        if (cart && productAfter <= productBefore) {
          response = await post(endpoint, {items: [...payload.items.slice(gifts.length, -1), product]});
          result = await response.json().catch(() => ({}));
          ownWindow.end = performance.now();
        } else if (cart) {
          response = null;
        }
      }
      if (!response) {
        // EasyGift drops a request identical to the one it just handled; show the cart as it is.
        await refresh();
      } else {
        if (!response.ok) throw new Error(result?.description || result?.message || drawer.dataset.error);
        const html = result?.sections?.['tg-cart'];
        if (html) render(html); else await refresh();
      }
      if (adding) { open(); announce(drawer.dataset.added); document.dispatchEvent(new CustomEvent('tg:cart:added', {detail: {items: payload.items}})); }
    } catch (error) {
      failed = true;
      reportError(error.message || drawer.dataset.error, form);
      try { await refresh(); } catch {
        // Offline: put back the last cart the server confirmed instead of the preview.
        if (beforePreview) {
          const current = beforePreview.target.isConnected ? beforePreview.target : drawer.querySelector('[data-cart-content]');
          current?.replaceWith(beforePreview.copy); beforePreview = null;
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = itemCount(); }); syncDetails();
        }
      }
    } finally {
      drawer.classList.remove('is-pending');
      if (adding && !previewing) stopAdding(form, failed);
      else if (adding) { if (failed && openedForAdd && drawer.open) drawer.close(); openedForAdd = false; }
      setBusy(false);
      ownRequestUrl = '';
      if (ownWindow.end === Infinity) ownWindow.end = performance.now();
      releaseAttributionRequest?.();
      if (giftRefreshPending) { giftRefreshPending = false; refresh().catch(error => reportError(error.message)); }
    }
  };
  // Replo landing pages and other apps add to the cart with their own /cart/add.js call
  // and show no feedback. Watch same-origin adds that follow a shopper click or key press
  // and open the drawer for them. Theme requests (X-TG-Cart) and EasyGift's internal
  // gift adds (?_easygift_internal) are ignored, so app auto-adds never pop the drawer.
  let lastGesture = 0;
  ['pointerdown', 'keydown'].forEach(type => document.addEventListener(type, () => { lastGesture = Date.now(); }, {capture: true, passive: true}));
  const isExternalCartAdd = (input, init) => {
    try {
      const request = typeof Request !== 'undefined' && input instanceof Request ? input : null;
      const method = String(init?.method || request?.method || 'GET').toUpperCase();
      if (method !== 'POST') return false;
      const headers = new Headers(init?.headers || request?.headers || undefined);
      if (headers.has('X-TG-Cart')) return false;
      const url = new URL(request ? request.url : String(input), location.href);
      if (url.origin !== location.origin || url.searchParams.has('_easygift_internal')) return false;
      return /\/cart\/add(?:\.js|\.json)?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  if (typeof window.fetch === 'function') {
    const pageFetch = window.fetch;
    window.fetch = function (input, init) {
      const watch = !busy && Date.now() - lastGesture < 10000 && isExternalCartAdd(input, init);
      const pending = pageFetch.apply(this, arguments);
      if (watch) {
        startAdding();
        pending.then(response => {
          const ok = response.ok;
          refresh().then(() => { stopAdding(null, !ok); if (ok) { open(); announce(drawer.dataset.added); } })
            .catch(error => { stopAdding(null, true); reportError(error.message); });
        }, () => { stopAdding(null, true); });
      }
      return pending;
    };
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-open-cart]')) {
      event.preventDefault(); open(); refresh().then(()=>{if(!countdownDeadline&&itemCount())startCountdown();}).catch(error => reportError(error.message)); return;
    }
    if (event.target.closest('[data-close-cart]')) drawer.close();
    const upsell = event.target.closest('[data-upsell-add]');
    if (upsell) {
      event.preventDefault();
      if (busy) return;
      const card = upsell.closest('[data-upsell-handle]');
      const item = {id: Number(card.dataset.selectedVariant), quantity: Number(card.dataset.selectedMin) || 1};
      const preview = upsellPreview(card, item.quantity);
      const gifts = giftsFor(item, preview ? preview.price : NaN, false);
      mutate('cart/add.js', {items: [...gifts, item]}, null, true, {preview, gifts});
      return;
    }
    const step = event.target.closest('[data-cart-step]');
    if (step) {
      event.preventDefault();
      if (busy || step.disabled) return;
      const next = stepQuantity(step);
      if (next.allowed) { next.input.value = next.quantity; updateQuantity(next.input); }
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      clearTimeout(quantityTimer);
      if (busy) return;
      const line = remove.closest('.tgcart-item');
      previewQuantity(line, 0);
      if (line) line.hidden = true;
      mutate('cart/change.js', {id: remove.dataset.key, quantity: 0});
    }
    if (event.target === drawer && event.clientX < drawer.getBoundingClientRect().left) drawer.close();
  });
  const updateQuantity = input => {
    clearTimeout(quantityTimer);
    if (!input.isConnected || busy || !input.checkValidity()) return;
    const line = input.closest('.tgcart-item');
    line?.classList.add('is-updating');
    previewQuantity(line, Number(input.value));
    return mutate('cart/change.js', {id: input.dataset.key, quantity: Number(input.value)});
  };
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (input) { clearTimeout(quantityTimer); quantityTimer = setTimeout(() => updateQuantity(input), 350); }
  });
  // Enter in a cart quantity box updates that line instead of submitting the form to checkout.
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest?.('[data-cart-quantity]');
    if (!input) return;
    event.preventDefault();
    updateQuantity(input);
  });
  document.addEventListener('change', event => {
    if(event.target.matches('[data-upsell-option]'))selectUpsell(event.target);
    const input = event.target.closest('[data-cart-quantity]');
    if (input) updateQuantity(input);
  });
  // Checkout: every quantity change is already saved, so the form posts only the checkout flag. Its positional
  // updates[] list goes stale when EasyGift adds or removes a gift line, and Shopify then answers 422 with the
  // /cart page. A quantity typed a moment ago is saved first, then checkout continues.
  let checkoutRetry = false;
  document.addEventListener('formdata', event => { if (event.target.matches?.('.tgcart-form')) event.formData.delete('updates[]'); }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('.tgcart-form')) {
      const unsaved = [...form.querySelectorAll('[data-cart-quantity]')].find(input => input.value !== input.closest('.tgcart-item')?.dataset.quantity);
      if (!busy && !(unsaved && !checkoutRetry)) { checkoutRetry = false; return; }
      event.preventDefault();
      if (busy || !unsaved.checkValidity()) return;
      checkoutRetry = true;
      Promise.resolve(updateQuantity(unsaved)).then(() => { if (!busy) drawer.querySelector('.tgcart-checkout[name="checkout"]')?.click(); });
      return;
    }
    if (!form.matches('[data-product-form]')) return;
    event.preventDefault();
    // The submit keeps propagating (as on the live theme) so AnyTrack, Shopify's pixels and analytics
    // still see the add to cart; preventDefault stops the page from navigating.
    if (busy || !form.checkValidity()) return;
    const item = formItem(form);
    if (!item.id) return;
    const preview = formPreview(form, item);
    const gifts = giftsFor(item, preview ? preview.price : NaN, form.hasAttribute('data-page-product'));
    // Add-on switches tied to this form (form="…", e.g. Complete the ritual) go in the same request; the product stays last.
    const addons = new FormData(form).getAll('tg_addon').map(Number).filter(Boolean).map(id => ({id, quantity: 1}));
    mutate('cart/add.js', {items: [...gifts, ...addons, item]}, form, true, {preview, gifts});
  }, true);
  syncDetails();
  bindGiftEvents();
  let giftBindingAttempts=0;const giftBindingTimer=setInterval(()=>{bindGiftEvents();if(giftEventsBound||++giftBindingAttempts>=30)clearInterval(giftBindingTimer);},1000);
  // The drawer's lines feed the gift predictor, so re-read the cart when the shopper comes back to this
  // page (another tab or the checkout may have changed it) and when the page returns from the back/forward cache.
  let hiddenAt = 0;
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { hiddenAt = Date.now(); return; }
    countdownDeadline = readDeadline(); updateCountdown();
    if (drawer.open || (hiddenAt && Date.now() - hiddenAt > 20000)) { cartFreshAt = 0; refresh().catch(() => {}); }
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { cartFreshAt = 0; refresh().catch(() => {}); } });
  // Product pages: fetch the cart thumbnail early so the instant preview shows the picture at once.
  const warmPreviewImage = () => {
    const holder = document.createElement('template');
    document.querySelectorAll('form[data-page-product] script[data-cart-preview]').forEach(script => {
      try { holder.innerHTML = JSON.parse(script.textContent).image || ''; } catch { return; }
      const img = holder.content.querySelector('img');
      if (!img) return;
      const warm = new Image();
      if (img.sizes) warm.sizes = img.sizes;
      if (img.srcset) warm.srcset = img.srcset;
      warm.src = img.src;
    });
  };
  if (document.querySelector('form[data-page-product]')) {
    const warmLater = () => ('requestIdleCallback' in window ? requestIdleCallback(warmPreviewImage, {timeout: 4000}) : setTimeout(warmPreviewImage, 2500));
    if (document.readyState === 'complete') warmLater(); else window.addEventListener('load', warmLater, {once: true});
  }
  if(new URLSearchParams(location.search).get('cart')==='open')open();
  window.tgCartReady = true;
  if (window.tgCartOpenPending) { window.tgCartOpenPending = false; open(); refresh().then(()=>{if(!countdownDeadline&&itemCount())startCountdown();}).catch(error => reportError(error.message)); }
})();
